import { Box, Flex } from '@chakra-ui/react'
import { useFormColors } from './FormThemeContext'

interface TabConfig {
  key: string
  label: string
  hasError?: boolean
  isDirty?: boolean
}

interface FormTabsProps<T extends string> {
  tabs: TabConfig[]
  activeTab: T
  onTabChange: (tab: T) => void
}

export function FormTabs<T extends string>({
  tabs,
  activeTab,
  onTabChange,
}: FormTabsProps<T>) {
  const c = useFormColors()

  return (
    <Flex gap={2}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.key
        const indicatorColor = tab.hasError ? c.error : tab.isDirty ? c.accent : null

        return (
          <Box
            key={tab.key}
            as="button" {...{ type: 'button' }}
            px={4}
            py={2}
            borderRadius="lg"
            fontSize="sm"
            fontWeight="500"
            cursor="pointer"
            bg={isActive ? `${c.accent}20` : 'transparent'}
            color={isActive ? c.accent : c.textMuted}
            border="1px solid"
            borderColor={
              indicatorColor
                ? indicatorColor
                : isActive
                  ? c.accent
                  : c.border
            }
            _hover={{
              bg: isActive ? `${c.accent}20` : c.bgHover,
            }}
            onClick={() => onTabChange(tab.key as T)}
            position="relative"
          >
            {tab.label}
            {indicatorColor && (
              <Box
                position="absolute"
                top="-2px"
                right="-2px"
                w="8px"
                h="8px"
                borderRadius="full"
                bg={indicatorColor}
              />
            )}
          </Box>
        )
      })}
    </Flex>
  )
}
